import React from 'react';
import PropTypes from 'prop-types';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles, IconButton, Typography } from '@material-ui/core';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import HittaLogo from '../HittaLogo/HittaLogo';
import translationPropType from '../../../proptypes/translationPropType';

const styles = () => ({
    brandWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    logo: {
        marginRight: 20,
    },
    nextSeparator: {
        fontWeight: 200,
    },
    next: {
        fontWeight: 200,
    },
});


const AppBarHeader = ({
    classes,
    width,
    handleDrawerOpen,
    translation,
}) => (
    <div className={classes.brandWrapper}>
        {isWidthUp('md', width) ? (
            <HittaLogo classes={classes.logo} size={40} />
        ) : (
            <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={handleDrawerOpen}
            >
                <MenuIcon />
            </IconButton>
        )}
        <Typography className={classes.title} variant="h6" color="inherit" noWrap>
            {translation.STATISTICS}
        </Typography>
        <Typography className={classes.nextSeparator} variant="h6" color="primary" noWrap>
                |
        </Typography>
        <Typography className={classes.next} variant="h6" color="textSecondary" noWrap>
            {translation.SYSTEM.toLowerCase()}
        </Typography>
    </div>
);


AppBarHeader.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    translation: translationPropType.isRequired,
    width: PropTypes.string.isRequired,
    handleDrawerOpen: PropTypes.func.isRequired,
};

export default withWidth()(withStyles(styles)(AppBarHeader));
